import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './Login.css'; 
import liff from "@line/liff";
import CONFIG from '../config';

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null); 
  const navigate = useNavigate();

  // Use the useLocation hook to access query parameters
  const location = useLocation();

  useEffect(() => {
    const initializeLiff = async () => {
      try {
        //Test: 2007240898-1ENEpa8P
        //Prod: 2007240898-OAAq903j
        await liff.init({ liffId: "2007240898-OAAq903j" });

        if (!liff.isLoggedIn()) {
          await liff.login();
        }

        // 1. Get LINE profile & decoded ID token
        const profile = await liff.getProfile();
        const lineUserIdData = liff.getDecodedIDToken().sub;
        console.log("LINE profile:", profile);
        console.log("LINE user ID:", lineUserIdData);

        // 2. Store line_user_id locally (if needed)
        localStorage.setItem('line_user_id', lineUserIdData);
        localStorage.setItem('line_profile_image', profile.pictureUrl)
        setLoading(true);

        if (lineUserIdData) {
          const getUrl = `${CONFIG.API_BASE_URL}/user-line-oa/get_user/${lineUserIdData}`;
          let existingUser = null;

          try {
            const getRes = await axios.get(getUrl);
            existingUser = getRes.data; 
            console.log("Existing user data:", existingUser);
          } catch (err) {
            console.log("No existing user found (or GET failed):", err);
          }

          // 4. If user exists, call the PUT /update/{id} with line_image_url
          if (existingUser && existingUser.id) {
            // Build form data for a URL-encoded PUT
            const form = new URLSearchParams();
            form.append("line_image_url", profile.pictureUrl);

            try {
              await axios.put(
                `${CONFIG.API_BASE_URL}/user-line-oa/update/${existingUser.id}`,
                form,
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Accept: "application/json",
                  },
                }
              );
              console.log("Successfully updated line_image_url on backend");
            } catch (putErr) {
              console.error("Error updating line_image_url:", putErr);
            }

            // 5. Now set userData and navigate
            setUserData(existingUser);
          }
        }
      } catch (error) {
        console.log("Error initializing LIFF / fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };

    initializeLiff();
  }, [navigate]);


  useEffect(() => {
    if (userData) {
      localStorage.setItem('userData', JSON.stringify(userData));
      navigate('/main-menu');
    }
  }, [userData, navigate]);
  
  

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const handleUserNameChange = (e) => {
    localStorage.setItem('username', e.target.value);
    setUsername(e.target.value);
  };

  const navigateToRegister = () => {
    const queryParams = new URLSearchParams(location.search);
    const website = queryParams.get('website');
    const scanFrom = queryParams.get('scan_from') || localStorage.getItem('scan_from') || '';
    const registerParams = new URLSearchParams();

    if (website) {
      registerParams.set('website', website);
    }
    if (scanFrom) {
      registerParams.set('scan_from', scanFrom);
    }

    const query = registerParams.toString();
    navigate(query ? `/register/?${query}` : '/register');
  };

  const navigateToForgotPassword = () => {
    navigate('/forgot-password');
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    localStorage.setItem('username', username);
    try {
      const response = await fetch('https://sso-uficon-xuvbdxggia-uc.a.run.app/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          username: username,
          password: password,
        }),
      });

      const data = await response.json();

      try{
        const ipResponse = await fetch('https://api.ipify.org?format=json');  // Get user's IP address
        const ipData = await ipResponse.json();
  
        const saveAutoLoginResponse = await axios.post('https://sso-uficon-xuvbdxggia-uc.a.run.app/save-autologin', new URLSearchParams({
          ip: ipData.ip,
          user_id: username,
          token: data.access_token,
        }));
      }catch(error){
        console.error('Error during save autologin:', error);
      }
      
      if (data.access_token) {
        // Redirect to WordPress site with the token
        axios.get(`${CONFIG.API_BASE_URL}/user-line-oa/get_user/${localStorage.getItem('line_user_id')}`)
        .then((response) => {
          setUserData(response.data);
        })
        .catch((error) => {
      
          navigate('/user-input');
        });
      } else {
        alert('Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Error during login:', error);
    }
  };

  return (
    <div className="App">
      {
        loading ? <div>Loading...</div> : <header className="App-header">

          <div
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    minWidth: '300px',
                    height: '100%',
                      backgroundColor: '#ffffff',
                    padding: '50px',
                    boxSizing: 'border-box',
                  }}
                >
              <img src="/assets/logo U-01.png" alt="Logo" className="logo-image" />
            <div className="welcome-text">Welcome to UFicon</div>
            <div className="login-header">เข้าสู่ระบบ</div>
            
            <div className="input-group">
              <div className="input-label">Email / User ID</div>
              <input
                type="text"
                style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                backgroundColor: '#f7f7f7',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                placeholder='example@email.com'
                value={username}
                onChange={handleUserNameChange}
              />
            </div>
            <div className="input-group password-group">
              <div className="input-label-container">
                <div className="input-label">Password</div>
              </div>
              <div className="password-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  style={{ marginTop: 10,
                width: '100%',
                height: 48,
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e5e5e5',
                backgroundColor: '#f7f7f7',
                color: '#333333',
                boxShadow: 'none',
                boxSizing: 'border-box',
                outline: 'none'
              }}
                  placeholder='password'
                  value={password}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className="input-label-forget" style={{fontWeight: 'medium'}} onClick={navigateToForgotPassword}>Forget Password?</div>
            </div>


            <div className="input-group remember-me-group">
              <div className="remember-me-container">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={handleRememberMeChange}
                />
                <label className="remember-me-label">จำฉันไว้</label>
              </div>
            </div>

            <div className="input-group">
              <button onClick={handleLogin} className="login-button">เข้าสู่ระบบ</button>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', fontFamily:'Prompt', fontSize:'13px',marginTop:'10px'}}>
              <div style={{ color: 'grey', padding: '5px' }}>ยังไม่มีบัญชีผู้ใช้ใช่หรือไม่?</div>
              <div style={{ color: '#00a9a5', fontWeight:'bold'}} onClick={navigateToRegister}>สมัครสมาชิก</div>
            </div>


          </div>
        

      </header>
      }
      
    </div>
  );
}

export default Login;
